import { useCallback } from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  TruncateText,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';
import { Suggestions } from '@mint-sdk/api-recommendations';

import NotReadBadge from '../../atoms/NotReadBadge/NotReadBadge.jsx';
import SuggestionDateSpan from '../../atoms/SuggestionDateSpan/SuggestionDateSpan.jsx';
import SuggestionEntity from '../../organisms/SuggestionEntity/SuggestionEntity.jsx';
import SuggestionCardStatus from '../SuggestionCard/SuggestionCardStatus.jsx';

type SuggestionCardExpandableProps = {
  onSelect: (suggestion: Suggestions.SuggestionResponseType) => void;
  suggestion: Suggestions.SuggestionResponseType;
};

const SuggestionCardExpandable = ({
  suggestion,
  onSelect,
}: SuggestionCardExpandableProps) => {
  const isNotRead =
    suggestion.status === Suggestions.Statuses.ACTIVE && suggestion.notRead;

  const handleSelectCard = useCallback(() => {
    onSelect(suggestion);
  }, [onSelect, suggestion]);

  return (
    <Accordion type="single" collapsible>
      <AccordionItem value={suggestion.uuid} onClick={handleSelectCard}>
        <AccordionTrigger className="flex h-14 flex-row justify-between">
          <div className="order-first flex w-[95%] flex-row items-start gap-2">
            <NotReadBadge invisible={!isNotRead} />
            <SuggestionCardStatus suggestion={suggestion} />
            <TruncateText tooltipClassName="max-w-200 break-all">
              <p
                className={cn(
                  'max-w-[85%] text-center',
                  typographyVariants({ variant: 'h4' }),
                )}
              >
                {suggestion.journeyName}
              </p>
            </TruncateText>
            <SuggestionDateSpan suggestion={suggestion} />
          </div>
        </AccordionTrigger>
        <AccordionContent className={'h-122'}>
          <SuggestionEntity
            key={`${suggestion?.id}-${suggestion?.status}`}
            suggestion={suggestion}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default SuggestionCardExpandable;
